import { Component, ChangeDetectionStrategy, input, signal, computed } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ITransaction } from '../../../../types';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'billing-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.scss'],
  animations: [
    trigger('dissolve', [
      state('true', style({
        height: '*',
        opacity: 1,
        display: 'block'
      })),
      state('false', style({
        height: '0px',
        opacity: 0,
        display: 'none'
      })),
      transition('false => true', [
        style({ display: 'block' }),
        animate(400, style({
          // transform: 'translateY(0%)',
          height: '*',
          opacity: 1
        }))
      ]),
      transition('true => false', [
        animate(400, style({
          // transform: 'translateY(-150%)',
          height: '0px',
          opacity: 0
        })),
      ])
    ])
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe]
})
export class ReceiptComponent {
  receipt = input.required<ITransaction>();
  show = signal<boolean>(false);

  details = computed(() => {
    const receipt = this.receipt();

    const discounted_amount = receipt.base_price != receipt.final_price ? (Number(receipt.base_price) - Number(receipt.final_price)).toFixed(2) : null;
    const price_excl_vat = (Number(receipt.final_price) - Number(receipt.calculated_vat)).toFixed(2);
    return [
      { key: 'Payment Method', value: `#### #### #### ${receipt.payment_method?.card?.digits ?? '####'}` },
      { key: 'Payment Type', value: receipt.payment_method?.card?.brand ?? '####' },
      { key: 'Seller', value: 'cloudigo Ltd' },
      { key: 'VAT Number', value: '2572-7812 MT' },
      { key: 'Package Price', value: `€ ${receipt.base_price}` },
      { key: 'Applied Discount', value: `€ ${discounted_amount}` },
      { key: 'VAT', value: `€ ${receipt.calculated_vat} (${(receipt.vat||0.18)*100}%)` },
      { key: 'Price (Excluding Vat)', value: `€ ${price_excl_vat}` },
      { key: 'Final Price', value: `€ ${receipt.final_price}` },
    ];
  });

  constructor() { 

  }

  download(){
    //TODO
  }
}
